export const PROCESS_LOGIN = "PROCESS_LOGIN";
export const GET_ID_TOKEN = "GET_ID_TOKEN";
export const SET_ERROR = "SET_ERROR";;
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_EMAIL = "SET_EMAIL";
export const RESET_STATE = "RESET_STATE";
export const LINK_SUCCESS = "LINK_SUCCESS";
export const SET_INVITATION_ACTION_LOADING = "SET_INVITATION_ACTION_LOADING"
export const SET_INVITATION_ACTION_SUCCESS = "SET_INVITATION_ACTION_SUCCESS"
export const SET_INVITATION_ACTION_ERROR = "SET_INVITATION_ACTION_ERROR"